document.addEventListener("DOMContentLoaded", function () {
  const marketSwitcherRoot = document.querySelector("[data-market-switcher]");
  const openSelector = document.getElementById("open-lang-selector");

  // Fallback flag list — only used if the server-rendered country JSON is
  // missing/malformed. The real list (codes, localized names, flags, home host,
  // apply flag) is rendered by snippets/market-switcher.liquid.
  const flagMap = {
    DK: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/denmark.png?v=1742990123",
    SE: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/sweden.png?v=1742990968",
    NO: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/norway.png?v=1742991092",
    FI: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/findland.png?v=1742991571",
    DE: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/germany.png?v=1742990123",
    AT: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Austria_svg.png?v=1746448445",
    FR: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/france.png?v=1742992825",
    IT: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/flag.png?v=1742992824",
    ES: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825",
    NL: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/netherlands.png?v=1746438517",
    BE: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Belgium.png?v=1746448509",
    EE: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Estonia_svg.png?v=1746440898"
  };

  // ISO country -> the storefront host that serves it. Mirrors the Shopify
  // Markets admin (14 REGION markets across 9 domains). A domain can serve more
  // than one country (.dk: DK/FO/GL, .de: DE/AT, .com: BE/EE/NL), which is why a
  // switch can't rely on the domain alone. Keep in sync with the case map in
  // snippets/market-switcher.liquid.
  const fallbackCountryHost = {
    DK: "www.soundstorexl.dk", FO: "www.soundstorexl.dk", GL: "www.soundstorexl.dk",
    SE: "www.soundstorexl.se",
    NO: "www.soundstorexl.no",
    FI: "www.soundstorexl.fi",
    DE: "www.soundstorexl.de", AT: "www.soundstorexl.de",
    FR: "www.soundstorexl.fr",
    IT: "www.soundstorexl.it",
    ES: "www.soundstorexl.es",
    NL: "www.soundstorexl.com", BE: "www.soundstorexl.com", EE: "www.soundstorexl.com"
  };

  const fallbackFlag = "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/EU.png?v=1742991477";

  // Ask the Shopify CDN for the flag at display size instead of the full source file.
  const withWidth = (url, w) => (url ? url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w : url);
  const normHost = (host) => String(host || "").toLowerCase().replace(/^www\./, "");

  const shopCountry = (function () {
    try {
      if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase();
    } catch (error) {}
    return "";
  })();
  const currentCountry =
    ((marketSwitcherRoot && marketSwitcherRoot.getAttribute("data-current-country")) || shopCountry || "").toUpperCase();
  const currentHost = normHost(
    (marketSwitcherRoot && marketSwitcherRoot.getAttribute("data-current-host")) || window.location.host
  );

  // Apply a country change through Shopify's native localization endpoint.
  // A same-origin POST sets the market cookie server-side and 302-redirects to
  // returnPath (the CLEAN path, no query), so the handoff param never survives
  // in the address bar, in shared links, or for crawlers.
  function applyCountry(countryCode, returnPath) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    const form = document.createElement("form");
    form.method = "POST";
    form.action = root + "localization";
    form.acceptCharset = "UTF-8";
    form.style.display = "none";
    const add = (name, value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };
    add("form_type", "localization");
    add("utf8", "✓");
    add("_method", "put"); // native localization form uses PUT via method override — required
    add("country_code", countryCode);
    add("return_to", returnPath);
    document.body.appendChild(form);
    form.submit();
  }

  // Arrival: a cross-domain jump to a shared-domain "extra" country (AT on .de;
  // NL/BE/EE on .com) hands the target off via ?country=XX. There is NO native
  // URL param that sets the market — Shopify only reads params for detection — so
  // we read it and apply it through the native localization endpoint, then land
  // on the clean URL. This also makes a manually typed ?country=xx work. Domain-
  // default countries never carry a param (the domain sets the market natively).
  // (switch_country = legacy handoff name from an earlier build; still honored.)
  (function handleArrival() {
    let url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return;
    }
    const params = url.searchParams;
    const requested = (params.get("country") || params.get("switch_country") || "").toUpperCase();

    if (requested && /^[A-Z]{2}$/.test(requested) && requested !== currentCountry) {
      applyCountry(requested, url.pathname); // navigates: POST -> 302 -> clean URL
      return;
    }

    let dirty = false;
    ["country", "switch_country"].forEach((param) => {
      if (params.has(param)) {
        params.delete(param);
        dirty = true;
      }
    });
    if (dirty) {
      try {
        const qs = params.toString();
        window.history.replaceState({}, document.title, url.pathname + (qs ? "?" + qs : "") + url.hash);
      } catch (error) {}
    }
  })();

  if (!marketSwitcherRoot || !openSelector) return;

  const popoverId = "market-switcher-popover";

  const popover = document.createElement("div");
  popover.id = popoverId;
  popover.className = "market-switcher__popover";
  popover.setAttribute("role", "menu");

  // Names/flags/hosts are rendered server-side; only fall back to English codes
  // if the JSON is missing or malformed.
  const countries = (function readCountries() {
    const dataNode = marketSwitcherRoot.querySelector("[data-market-switcher-countries]");
    if (dataNode) {
      try {
        const parsed = JSON.parse(dataNode.textContent);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (error) {}
    }
    return Object.keys(flagMap).map((code) => ({ code: code, name: code, flag: flagMap[code] }));
  })();

  const hostByCode = {};
  const applyByCode = {};
  countries.forEach((country) => {
    const code = String(country.code || "").toUpperCase();
    if (!code) return;
    // Full canonical host (keep www). normHost is only for comparison — the
    // market web presence is the www domain; the apex isn't wired and 404s.
    hostByCode[code] = country.host || fallbackCountryHost[code] || "";
    // apply = shares its domain with a sibling country → must be set explicitly
    // after a cross-domain jump, because plain nav keeps a prior sibling's cookie
    // (DK, DE, AT, NL, BE, EE). Solo domains load correctly on plain nav.
    applyByCode[code] = !!country.apply;
  });

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (character) => {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });

  popover.innerHTML = `
    <div class="market-switcher__list" role="none">
      ${countries
        .map((country) => {
          const countryCode = escapeHtml(country.code);
          const countryName = escapeHtml(country.name);
          const flagUrl = escapeHtml(withWidth(country.flag || fallbackFlag, 36));
          return `
            <button type="button" class="market-switcher__item" role="menuitem" data-country-code="${countryCode}">
              <img class="market-switcher__flag" src="${flagUrl}" alt="" width="18" height="12" loading="lazy" decoding="async" />
              <span class="market-switcher__name">${countryName}</span>
            </button>
          `;
        })
        .join("")}
    </div>
  `;

  marketSwitcherRoot.appendChild(popover);

  const setOpen = (isOpen) => {
    marketSwitcherRoot.classList.toggle("is-open", isOpen);
    openSelector.setAttribute("aria-expanded", String(isOpen));
    if (!isOpen) {
      openSelector.focus();
    }
  };

  const toggleOpen = () => {
    setOpen(!marketSwitcherRoot.classList.contains("is-open"));
  };

  openSelector.setAttribute("aria-haspopup", "menu");
  openSelector.setAttribute("aria-controls", popoverId);
  openSelector.setAttribute("aria-expanded", "false");

  openSelector.addEventListener("click", (event) => {
    event.preventDefault();
    toggleOpen();
  });

  document.addEventListener("click", (event) => {
    if (!marketSwitcherRoot.classList.contains("is-open")) return;
    if (marketSwitcherRoot.contains(event.target)) return;
    setOpen(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (!marketSwitcherRoot.classList.contains("is-open")) return;
    event.preventDefault();
    setOpen(false);
  });

  popover.addEventListener("click", (event) => {
    const item = event.target.closest(".market-switcher__item");
    if (!item) return;

    const target = String(item.dataset.countryCode || "").toUpperCase();
    if (!target) return;

    const targetHost = hostByCode[target] || fallbackCountryHost[target] || "";
    if (!targetHost) {
      // Unknown country (no market) — do nothing rather than send to a dead URL.
      setOpen(false);
      return;
    }

    // No-op only if we're already in this country AND already on its domain. On
    // .com a Danish visitor's country is DK (geo) even though DK lives on .dk, so
    // picking DK must still hop to .dk rather than silently close.
    if (target === currentCountry && normHost(targetHost) === currentHost) {
      setOpen(false);
      return;
    }

    const path = window.location.pathname;
    const hash = window.location.hash;
    const isSafePath = !/\/(checkout|account|cart|policies)(\/|$)/i.test(path);
    const targetPath = isSafePath ? path : "/";

    // Track the switch as an explicit GA4 event (GTM trigger on "market_switch",
    // params from_market/to_market). GA4 uses sendBeacon, so the hit generally
    // survives the navigation below.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "market_switch",
      from_market: currentCountry,
      to_market: target
    });

    // Compare host-only (ignore www); navigate/POST to the FULL www host.
    if (normHost(targetHost) === currentHost) {
      // Same domain, different country (NL/BE/EE on .com, DE/AT on .de): set it
      // in place via the localization POST — no cross-domain hop, no URL param.
      applyCountry(target, targetPath);
      return;
    }

    // Cross-domain. The domain IS the native market selector, so plain navigation
    // loads the target market. Solo-domain countries (SE/NO/FI/FR/IT/ES) need
    // nothing more. Multi-country domains (DK; DE/AT; NL/BE/EE) can retain a prior
    // sibling country via the localization cookie, so hand the target off via
    // ?country=XX and apply it through the native localization endpoint on arrival.
    const base = "https://" + targetHost;
    if (applyByCode[target]) {
      window.location.href = base + targetPath + "?country=" + target.toLowerCase() + hash;
    } else {
      window.location.href = base + targetPath + hash;
    }
  });
});
